const API = process.env.REACT_APP_BACKEND_URL;
const PASSTHROUGH = /^(data:|blob:)/;

// Descriptive file name for the optimised URL (Google Images reads it; the .webp extension makes CDN edges cache it).
const fileName = (src) => {
  const base = src.split('?')[0].split('/').filter(Boolean).pop() || 'photo';
  const stem = base.replace(/\.[a-z0-9]{2,5}$/i, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60);
  return `hotel-uma-premium-ulcinj-${stem || 'photo'}`;
};

// Resized WebP via the backend optimiser (/api/img); inline sources pass through.
export const optimized = (src, w = 800) =>
  (!src || PASSTHROUGH.test(src) ? src : `${API}/api/img/${fileName(src)}.webp?u=${encodeURIComponent(src)}&w=${w}`);

export const srcSetFor = (src, widths = [400, 800, 1200]) =>
  (!src || PASSTHROUGH.test(src) ? undefined : widths.map((w) => `${optimized(src, w)} ${w}w`).join(', '));
